<template>
  <el-aside class="aside">
    <!-- unique-opened只展开一个 -->
    <!-- router开启路由模式 -->
    <el-menu
      :unique-opened="true"
      :router="true"
      :default-active="obj.defaultActive"
      background-color="#fff"
      text-color="#333333"
      active-text-color="#fff"
      @select="onMenuSelect"
    >
      <template v-for="item in menus">
        <el-submenu
          v-if="item.children && item.children.length && item.meta.dropDown"
          :index="item.path"
          :key="item.path"
          v-show="
            !item.meta.hidden &&
            item.meta.businessType &&
            item.meta.businessType.includes(businessType)
          "
          :data-router-name="item.name"
        >
          <template slot="title">
            <i :class="item.meta.icon"></i>
            <span>{{ item.meta.title }}</span>
          </template>
          <!-- 二级菜单 -->
          <template v-for="subItem in item.children">
            <el-submenu
              v-if="
                subItem.children &&
                subItem.children.length &&
                subItem.meta.dropDown
              "
              :index="subItem.path"
              :key="subItem.path"
              v-show="
                !subItem.meta.hidden &&
                item.meta.businessType &&
                subItem.meta.businessType.includes(businessType)
              "
            >
              <template slot="title">
                <i :class="subItem.meta.icon"></i>
                <span>{{ subItem.meta.title }}</span>
              </template>

              <!-- 三级菜单 -->
              <el-menu-item
                v-for="threeItem in subItem.children"
                :index="threeItem.path"
                :key="threeItem.path"
                v-show="!threeItem.meta.hidden"
              >
                <i :class="threeItem.meta.icon"></i>
                <span slot="title">{{ threeItem.meta.title }}</span>
              </el-menu-item>
            </el-submenu>

            <el-menu-item
              v-else
              :index="subItem.path"
              :key="subItem.path + 1"
              v-show="
                !subItem.meta.hidden &&
                item.meta.businessType &&
                subItem.meta.businessType.includes(businessType)
              "
            >
              <i :class="subItem.meta.icon"></i>
              <span slot="title">{{ subItem.meta.title }}</span>
            </el-menu-item>
          </template>
        </el-submenu>

        <!-- 一级菜单 -->
        <el-menu-item
          v-else
          :index="item.path"
          :key="item.path + 1"
          v-show="
            !item.meta.hidden &&
            item.meta.businessType &&
            item.meta.businessType.includes(businessType)
          "
        >
          <i :class="item.meta.icon"></i>
          <span slot="title">{{ item.meta.title }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </el-aside>
</template>
<script>
import { mapActions } from "vuex";
import { removeSessionStorageQuery } from "@/utils/common";

export default {
  data() {
    return {
      menus: [],
      obj: {
        defaultActive: this.$route.meta.hidden
          ? this.$route.meta.targetPath
          : this.$route.path,
      },
      menuList: [],
    };
  },
  watch: {
    $route(to) {
      if (to.meta.hidden) {
        this.obj.defaultActive = to.meta.targetPath;
      } else {
        this.obj.defaultActive = this.$route.path;
      }
      let menuIndex = this.menuList.findIndex((item) => {
        return item.path == to.path;
      });
      if (menuIndex > -1) {
        this.menus = this.menuList[menuIndex].children;
      }
    },
    "$store.state.headMenuPath": {
      handler(val) {
        this.handleMenus(val);
      },
    },
    "$route.query.$businessType": {
      handler(val) {
        this.businessType = val ? val : "home";
      },
    },
  },
  created() {
    this.saveHeadMenuPath(this.$route.meta.headMenuPath);
    this.handleMenus(this.$store.state.headMenuPath);
    let { $businessType } = this.$route.query;
    this.businessType = $businessType ? $businessType : "home";
  },
  methods: {
    ...mapActions(["saveHeadMenuPath"]),
    handleMenus(headMenuPath) {
      let menuList = this.$router.options.routes.filter((item) => {
        return !item.meta.hidden;
      })[0].children;
      this.menuList = menuList;
      let headMenu = menuList.filter((item) => item.path == headMenuPath)[0];
      this.menus = headMenu.children;
    },

    onMenuSelect() {
      // 菜单改变时候 清除 缓存的 表格查询条件数据。
      removeSessionStorageQuery();
    },
  },
};
</script>

<style lang="scss" scoped>
.aside {
  width: 230px !important;
  padding-top: 10px;
  overflow-x: hidden;
  background-color: #ffffff;
  border-right: 1px solid #e9ebee;
  & > .el-menu {
    & > .el-menu-item {
      font-weight: bold;
    }
  }
  .el-menu {
    border-right: none;
    background-color: #ffffff !important;
    padding: 0 10px;
    .el-menu-item {
      position: relative;
      height: 50px;
      line-height: 50px;
      font-size: 18px;
      background-color: #ffffff !important;
      color: #333333 !important;
      padding: 0;
      min-width: 100%;
      &.is-active {
        background: linear-gradient(90deg, #06949a 0%, #09c2c9 100%) !important;
        border-radius: 6px;
        overflow: hidden;
        color: #ffffff !important;
        i {
          color: #fff;
        }
      }
      i {
        margin-right: 5px;
        color: #048489;
      }
    }
    ::v-deep .el-submenu {
      .el-submenu__title {
        height: 60px;
        line-height: 60px;
        font-size: 18px;
        color: #333333 !important;
        background-color: #ffffff !important;
        font-weight: bold;
        i {
          color: #048489;
          font-size: 18px;
          margin-right: 5px;
          &.el-submenu__icon-arrow {
            margin-top: -6px;
          }
        }
      }
      &.is-active {
        .el-submenu__title {
          color: #048489 !important;
          // i {
          //   color: #048489;
          // }
        }
      }
    }
  }
}
</style>
